module.exports = __webpack_public_path__ + "img/146ne.4f95efcd.svg";